import { HorizontalContainer } from '@american-autonomy/ag-ui';

import MiniSeverityIcon from 'components/airspace/MiniSeverityIcon';

import { SEVERITY_NAMES, SEVERITY_ORDER, TEST_ID } from './constants';
import type { FunctionComponent, Props, Severity } from './types';

import styles from './styles.module.scss';

// Map each Severity to the SCSS class that carries its chip tint + text color.
// Object maps only — no switch per project rules.
const CHIP_CLASS: Record<Severity, string> = {
    advisory: styles.advisory,
    critical: styles.critical,
    info: styles.info,
    prohibited: styles.prohibited,
    safe: styles.safe,
    warning: styles.warning
};

// ag-ui HorizontalContainer and Wrapper don't forward aria-label/title onto
// the rendered DOM. The chip itself is a native <span> so assistive tech + the
// tooltip attribute can land on the element (same pattern as OrderBadge /
// ComplianceRow elsewhere in the codebase).
const AdvisoryCountChips: FunctionComponent<Props> = ({
    className = '',
    counts,
    testId = TEST_ID
}) => {
    const activeSeverities = SEVERITY_ORDER.filter(severity => (counts[severity] ?? 0) > 0);

    return (
        <HorizontalContainer
            className={`${styles.advisoryCountChips} ${className}`}
            testId={testId}>
            {activeSeverities.map(severity => {
                const count = counts[severity] ?? 0;
                const label = `${count} ${SEVERITY_NAMES[severity]}`;

                return (
                    <span
                        aria-label={label}
                        className={`${styles.chip} ${CHIP_CLASS[severity]}`}
                        data-testid={`${testId}-${severity}`}
                        key={severity}
                        title={label}>
                        <MiniSeverityIcon
                            severity={severity}
                            testId={`${testId}-icon-${severity}`}
                        />

                        {count}
                    </span>
                );
            })}
        </HorizontalContainer>
    );
};

export default AdvisoryCountChips;
